// extracted by mini-css-extract-plugin
export var avatarContainer = "my-account-module--avatar-container--b9e1f";
export var avatarCurrent = "my-account-module--avatar-current--31803";
export var avatarName = "my-account-module--avatar-name--b6eb7";
export var avatarNotCurrent = "my-account-module--avatar-not-current--5e3ea";
export var changeButton = "my-account-module--change-button--5ef08";
export var container = "my-account-module--container--b7cf7";
export var editButton = "my-account-module--edit-button--4ba90";
export var editButtonText = "my-account-module--edit-button-text--eab9f";
export var header = "my-account-module--header--d371b";
export var justifyCenter = "my-account-module--justify-center--2d51b";
export var myAccount = "my-account-module--my-account--e25c9";
export var sidebar = "my-account-module--sidebar--06984";
export var title = "my-account-module--title--e91e9";